import { useEffect, useContext, useCallback } from 'react';
import OrderConfirmationContext from '../../../context/OrderConfirmationContext';
import $window from '../../../tools/window';
import useLog from '../../useLog/useLog';
import useScript from '../../Helpers/useScript';
import useSwitchesFromContext from '../../../hooks/useSwitchesFromContext';

export default function StyliticsTrackPurchase() {
  const { orderConfirmationData } = useContext(OrderConfirmationContext);
  const logger = useLog('orderConfirmationPage.stylitics');
  const { getSwitchValue } = useSwitchesFromContext();
  const styliticsTrackPurchaseJSUrl = getSwitchValue('styliticsJSUrlOCP');
  const styliticsLocale = getSwitchValue('STYLITICS_LOCALE');

  const [styliticsJSUrlScript] = useScript({
    id: 'stylitics-script',
    src: styliticsTrackPurchaseJSUrl,
  });

  const track = useCallback(() => {
    if (styliticsTrackPurchaseJSUrl) {
      if (!orderConfirmationData || !$window.StyliticsPixel) {
        return;
      }

      try {
        const items = [];

        // Extract order items from orderConfirmationData
        const orderItems = orderConfirmationData?.bagItems?.items || [];
        const orderId = orderConfirmationData?.orderTotals?.orderId;
        const orderTotal = orderConfirmationData?.orderTotals?.cartTotalAmount;
        const currency = orderConfirmationData?.orderTotals?.currency;

        // Get brand, region and environment information
        const brand = orderConfirmationData?.brand === 'hol' ? 'hollister' : 'abercrombie';
        const region = orderConfirmationData?.region || 'US';
        const environment = $window.location.host === 'www.abercrombie.com' ? 'production' : 'staging';
        const locale = styliticsLocale;
        const client = region === 'US' ? brand : [brand, '_', region].join('').toLowerCase();

        // Create items array for Stylitics
        orderItems.forEach((item) => {
          items.push({
            id: item?.item?.productContent?.kicId || item?.item?.productContent?.productId,
            price: item?.item?.productContent?.productPrice?.discount
            || item?.item?.productContent?.productPrice?.original,
          });
        });

        // Initialize Stylitics pixel
        if ($window.StyliticsPixel) {
          $window.StyliticsPixel({
            environment,
            client,
            orderId,
            orderTotal,
            currency,
            items,
            locale,
          });

          logger.info('Stylitics pixel initialized successfully');
        }
      } catch (error) {
        logger.error(`Error initializing Stylitics pixel: ${error.message}`);
      }
    } else {
      logger.warn('Stylitics JS URL is not defined');
    }
  }, [styliticsTrackPurchaseJSUrl, orderConfirmationData, styliticsLocale, logger]);

  useEffect(() => {
    if (styliticsJSUrlScript?.loaded) {
      track();
    }
  }, [styliticsJSUrlScript, track]);

  return null;
}
